module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_num"
  }, [_vm._v("Chapter Two")]), _vm._v(" "), _c('h2', {
    staticClass: "chap_head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The British Empire in the Far East Prepares, 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he British Empire covered the globe in the early decades of the twentieth century comprising colonies, protectorates and other possessions in the West Indies, Africa, Middle East and the Far East. Britain’s imperial possessions in the Far East had grown in the late nineteenth century to include amongst others Malaya, Burma, Hong Kong and northern Borneo. During the First World War the British and its imperial forces had fought in Africa and the Middle East against the Germans and Ottoman Turks. Imperial Japan joined the Entente Powers and had fought against the Germans in China in 1914. Although seen by the West rather wistfully in military terms as ‘jolly Oriental chaps’, the Japanese soldiers had proven themselves as tough and often brutal fighters since 1894. The aggression of the Japanese in Manchuria and China made the rest of the world fully aware of their capabilities.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("By the late 1930s it was obvious that the threat to the British Empire in the Far East now came from the Japanese. It was also recognized that measures would have to be taken to counter the threat of the Japanese but these were constrained by economic problems during the 1920s and 1930s. Like every other world nation, Great Britain had been badly affected by the Depression of the 1930s. The resulting shortage of funds led to a number of necessary defence economies which adversely affected the military forces in the Far East, and particularly during the 1930s. In Malaya for instance in the late 1930s the military budget was so tight that only £60,000 was allocated to improve the defences north of Singapore. Almost the whole of this paltry figure was spent on building machine-gun emplacements in the state of Johore in the south of Malaya. Likewise, British army units stationed in the Far East often saw their strength diminished by cuts, including in Burma. There the only British army units stationed in the late 1930s were the 1st Battalion of the Gloucestershire Regiment and a battalion of the 2nd King’s Own Yorkshire Light Infantry. Both of these battalions had been further weakened by the stripping of some of their officers who had been transferred to India. This shortage of officers and NCOs meant that neither battalion could muster more than two companies’ worth of troops.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("As war with Japan grew more likely the various locally recruited volunteer units took on a new importance. Although they were seen as more important to their homeland’s defence, their reliability was often called into question by the British officers in command of them. After the outbreak of war with Germany in September 1939 the imperial forces in the Far East were given even less priority. Reinforcements of men and equipment were not forthcoming and the Far East was at the back of the queue where both were concerned. When Britain was fighting for its survival in 1940 and 1941 the perceived threat from the Japanese was not as important as the very real and immediate threat from Nazi Germany. For this reason from September 1939 until December 1941 the British forces in the Far East received relatively little in the form of new military equipment. For the foreseeable future the British army in Burma, Malaya and the other Far Eastern possessions would have to make do largely with what they already had.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In September 1941 the total number of troops available to defend the British Empire in the East were, in Malaya, 11,000 British, 35,000 Indians, 25,000 Australians and about 17,000 Malayan volunteers. Burma was defended by 2,000 British, 7,000 Indian and 26,000 Burmese troops of doubtful value. Included in the Burmese total were the six battalions of the Burma Frontier Force (BFF) formed largely from units of the Burma Military Police. The personnel of the BFF were nearly all Indians or Gurkhas and there was no intention that they be used in the front line. Many of the local recruits for the Burmese units were suspected of disloyalty and of having sympathy with the Nationalist cause. Northern Borneo was divided into four separate ‘protectorates’ rather than colonies. These were the island of Labaun, Northern Borneo, Sarawak and Brunei, the first two having a British administration. Brunei was an independent sultanate which still depended for its protection on the British army, as did Sarawak. Sarawak was a kingdom which had been ruled since 1841 by a British family, one of whom held the hereditary position of rajah. The total force available to protect the whole of Northern Borneo was 1,000 Indian troops and 2,500 poorly trained volunteers. In December 1941 the Hong Kong garrison stood at 19,000, and 5,500 of this number were made up of local European and Asian volunteers. New Guinea, the huge island to the north of Australia, was divided down the middle between the Dutch and Australians. In 1941 the island was defended by a militia force recruited from the expatriate Australian population. This force was reinforced by three militia battalions which arrived in New Guinea between March and December 1941. The average age of the militia was 18 or 19 years old and these youths for several months in 1942 had to battle the invading Japanese army alone. There were also a number of New Guinea volunteer units formed with the first, the Papua Infantry Battalion, mustering about 600 men. In the Pacific the British-ruled islands usually had some kind of regular or paramilitary force to defend them. These were often small and poorly armed with Lee–Enfield rifles and the odd Bren gun, which was the heaviest weapon in use. The Kingdom of Tonga was ruled by Queen Salote Tupou III who gave her full support to the British. By early 1941 the Tongan Defence Force had 2,700 regulars and was backed by 10,000 part-time home guard soldiers.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_10a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("These two photographs show the Burmese Frontier Force training with their mountain guns in September 1941. The BFF was made up largely of Indian units with some Burmese native units mixed in as well. In this photograph the gun crews are demonstrating their skills in unloading their guns from the mules carrying the dissembled parts. On the right of the photo the three gun crew hold the barrel of the gun using carrying poles ready to place it on the carriage on the left of the image.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_10b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In this second photograph the Indian artillerymen of the BFF are putting together their QF 3.7in howitzer Mk 1 gun. According to the original caption to the photograph it took a well–trained crew 1 minute to ‘unlimber, assemble and get their mountain guns into action’. The original guns which were employed largely on the North-West Frontier had large shields but these were often removed in jungle conditions.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_11a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A machine-gun section of the Burma Rifles is given instruction in the operation of the Bren gun in the summer of 1941. The Burma Rifles recruited mainly from amongst the Burmese hill tribes such as the Karen, Kachin and Chin. When war became likely the original four battalions were doubled to eight but this was at the expense of their general performance. Some recruits for the expanded force had to come from the majority Burmese population who were regarded as ‘unreliable’. By 1940 there were only about a 1,000 officers and men of Burmese extract in the Burma Rifles and BFF.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_11b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Soldiers of the 2nd King’s Own Yorkshire Light Infantry Regiment take part in anti-aircraft practice with their Bren gun in the centre of the Burmese capital Rangoon. They are wearing khaki drill shirts and shorts with the India pattern cork sun helmet which was widely worn in Burma in 1941–2. In the background is the famous Schwe Dragon Pagoda, one of the most important Buddhist shrines in Burma.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_12a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Indian mountain artillerymen pose proudly with a Thompson sub-machine gun during an exercise in the hills of eastern Burma in 1941. They belong to the BFF which relied for many of its personnel on Indians rather than Burmese. The Thompson is an early model M1928 AI with a vertical fore grip and a large fifty-round drum magazine. This model is heavy and rather cumbersome for jungle fighting but the BFF would have been lucky to receive any due to demands from other fronts. In December 1941 all the BFF columns were supplied with five Thompsons and a single 2in mortar to improve their firepower.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_12b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Air Chief Marshal Sir Robert Brooke-Popham, Commander-in-Chief of the British Far East Command, in conference at his Singapore headquarters, December 1941. Brooke-Popham was soon replaced by General Wavell before the end of 1941 whose new command was known as the ABDA, or ‘American-British-Dutch-Australian’ Command. During his tenure Brooke-Popham had stated that there were no signs that the Japanese were going to invade anyone!")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_13a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Indian dock workers un-crate a Blenhiem Mk IV medium bomber in Singapore before the outbreak of war with Japan. The defence of Malaya and Singapore would depend largely on the weak RAF forces stationed there. One notable mission that the Blenhiems undertook in 1941–2 was the bombing of Bangkok, capital of Thailand, in January 1941. Blenhiems were slow bombers and had been largely replaced in RAF service by 1942, although they continued to serve in the Far East until 1943.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_13b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Vickers M1912 machine-gunners of the Manchester Regiment take part in pre-war jungle training in Malaya in early 1941. The caption to this photograph sums up quite well the unrealistic view of the jungle-fighting capabilities of the British forces in 1941–2 in the Far East. It says that the Vickers ‘is easily recognised because of its distinctive cooling drum, but an approaching enemy will not find it easy to spot the camouflaged gun team’. Unfortunately it was often the Allied troops who did not spot the Japanese troops’ outflanking positions, like this one.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_14a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Volunteers of the Singapore Volunteer Corps leave their barracks to go to their jungle training camp in 1941. They have drawn from the unit armoury ammunition for their Lewis guns, a flare pistol and a Boys anti-tank rifle. Their khaki drill shirts and shorts and woollen socks are topped off with the archetypal cork solar topee. Webbing equipment is the older 1908 pattern no longer in service with the regular British army.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_14b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A two-man Indian crew of a Boys Mk I 0.55 anti-tank rifle in the Malayan jungle take part in firing practice in the months leading up to the start of the war against Japan. The Far East theatre was not given priority for weaponry and equipment before and after the outbreak of the war in 1939. For this reason this almost obsolete weapon would have been gratefully received by the Indians preparing to defend Malaya against possible Japanese aggression.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_15.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian soldier demonstrates the anti-mosquito clothing and equipment which should have been available to all troops in Malaya. Although not very comfortable in the humid conditions, the net cover, long gloves and trousers tucked into his puttees provided protection. Malaria was to affect thousands of troops on both sides throughout the fighting in South-East Asia. The disease often resulted in units having to fight at well below full strength with a large proportion of these troops in the sick bay.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_16.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A 3in mortar crew of the Malay Regiment takes part in training during the summer of 1941. The Malay Regiment had been formed in March 1933 after the British had overcome their hesitance at arming Malays. By 1938 the regiment had a strength of 380 men which was further increased when war broke out in Europe in 1939. In February 1940 an additional company was added to the regiment and by July it had been merged with the 2nd Loyal Brigade. By 1941 the regiment was known as the 1st Malaya Brigade and by the time it took its defence positions in Singapore it had 1,400 men.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_17a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A column of Bren-gun carriers and light trucks of the Australian army moves across a bridge in Malaya in August 1941. The Bren-gun carrier was never intended to be a combat vehicle and had been designed to transport troops into battle. There were a number of this type of armoured vehicle in service in the Far East in 1941 but many ended up abandoned in Singapore. Officially, every British infantry battalion was supposed to have thirteen carriers but in 1941 few units had their full complement.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_17b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian troops march out of their barracks in Malaya to go on an exercise as they prepare for the expected war with Japan in 1941. In September 1939 the Australian government immediately declared war on Germany as part of the British Empire. Although the Australian Imperial Forces (AIF) were to play a crucial role in fighting in North Africa and the Far East, in 1939 they were ill prepared. With only 3,000 men in the regular army and with only 6 cruisers and 5 destroyers in its navy, rapid expansion of the armed forces was a priority. Within a year there were 40,000 additional soldiers trained including the 8th Division, which was despatched to help defend Malaya.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_18a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A QF 2-pounder anti-tank gun of the Australian army in Malaya has been sited on the edge of the jungle. It had already seen service with the Australians in the North African desert where its poor range meant it had to be dug in in order to be able to engage the enemy. During the fighting in Malaya the crews of the Australian 2-pounders were able to use their experience to successfully destroy a number of Japanese tanks.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_18b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian motorcycle despatch riders parade astride their Triumph 3SW motorcycles, one of several types used during 1941–2. Amongst the others were Norton, Indian, BSA and Aerial motorcycles, mostly imported from Britain. These men are amongst the Australian units that arrived in Malaya on 18 February 1941. They had plenty of time to acclimatize to the tropical conditions whilst some of their compatriots arrived at the end of the campaign.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_19.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Lewis light machine-gunners of the Straits Settlement Volunteer Force train during the months leading up to the Japanese invasion. In total there were 17,000 Malay volunteers of European, Eurasian or Asian ethnicity in December 1941. The two main forces were four battalions of the Straits Settlement Volunteers and four battalions of the Federated Malay States Volunteer Force. There was also a number of smaller volunteer units of infantry and light artillery in the other states of Malaya.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_20.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A line of recently arrived Marmon-Herrington Mk III MFF armoured cars wait to be assigned to their new units in Singapore in December 1941. By late November 1941 a total of 84 Marmon-Herrington armoured cars had been shipped to Malaya from South Africa. Some of these arrived just before the war broke out and their drivers had to be given a brief training course before going to the front. The Australian 8th Infantry Division and the 3rd Indian Cavalry Regiment were each given some of the more serviceable armoured cars.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_21a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("This parade in August 1941 by the 2/15th Punjab Regiment is taking place in Kuching, the administrative capital of the British territory of Sarawak. It was organized to try and raise the profile of the Sarawak Volunteers, a local defence force, and stimulate recruitment. After an invasion scare in April 1941 the authorities in Labaun Island, Sarawak, Brunei and northern Borneo tried to build up their meagre defences. These four territories shared the vast island of Borneo with Dutch Borneo and were a real outpost of empire. Before the Japanese invaded in December 1941 an air-raid precautions unit and other civil defence groups had been formed. In addition an old para-military force, the Sarawak Rangers, had been re-formed mainly with older veterans. In December 1941 the garrison had a strength of 2,565 men, both regulars and volunteers, equipped with ten Bren-gun carriers, four 18-pounder field guns and a number of Boys anti-tank rifles and mortars.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_21b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("New Guinean local forces were initially made up of the Papua Infantry Battalion, which started with 300 troops. These recruits are going through basic training in late 1941 in Port Moresby, the administrative capital of British New Guinea. In January 1942 this now expanded unit was the first to encounter the Japanese imperial forces when they landed on the island. Its 77 Australian officers and 550 other ranks held up the Japanese advance with a series of skilful ambushes and other surprise attacks.")])]), _c('p', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_22a.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Armed policemen of the Solomon Islands Protectorate Constabulary are seen on parade in 1941, when their force numbered 100 men. They, along with the Solomon Islands Defence Force, were responsible for protecting the various islands from the Japanese. The Defence Force, with a strength of 680 men, had been formed in 1939 but due to budget cuts was to be disbanded in February 1942. When the Japanese invaded the islands the disbandment had not taken place and most of the men served the Allied forces during the Solomons Campaign from 1942 onwards.")]), _vm._v(" "), _c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_22b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The crew of an anti-aircraft gun go through their drill in front of the public in Colombo, capital of Ceylon, in 1940. Ceylon was seen by the Japanese as a potential conquest as it would enable them to protect their position in the Indian Ocean. If they could invade Ceylon they would be able to use it as a base to totally disrupt any Allied shipping in the Indian Ocean. Any threat to Ceylon would come from the sea so there were four coastal batteries at Colombo and five at the main port of Trincomalee. During the war the garrison of Ceylon was made up of ten volunteer infantry battalions and four artillery regiments and was bolstered by British and Australian troops.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673051b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter02.vue
// module id = 78
// module chunks = 0